import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Flex from '../Flex';

const defaultProps = {
  noPadding: false,
  children: null,
};

const propTypes = {
  noPadding: PropTypes.bool,
  children: PropTypes.node,
};

const ModalFooter = ({
  noPadding,
  children,
}) => (
  <Flex
    alignItems="center"
    justifyContent="center"
    className={classnames(
      !noPadding && 'pb-10',
    )}
  >
    {children}
  </Flex>
);

ModalFooter.defaultProps = defaultProps;
ModalFooter.propTypes = propTypes;

export default ModalFooter;
